module.exports = __webpack_public_path__ + "img/air_press.3c99fe68.svg";